import { render, staticRenderFns } from "./ProductBalanceTable.vue?vue&type=template&id=2d5f88a6&scoped=true"
import script from "./ProductBalanceTable.vue?vue&type=script&lang=js"
export * from "./ProductBalanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f88a6",
  null
  
)

export default component.exports